// dependency-graph-ignore-file
import { type DefaultRootState } from '@databases/redux';
import { isEmptyValue } from '@databases/utils/database/field-types';
import { getConvertedDatabaseValue } from '@databases/utils/database/utils';
import { selectUserByIdOptional } from '@databases/utils/redux/users/selectors';
import { partial, partialRight } from 'lodash-es';

import type { StateSelectors } from './state-selectors.ts';

/** State selectors whose data source is the Redux store. */
export function createReduxStateSelectors(reduxState: DefaultRootState): StateSelectors {
  return {
    getConvertedDatabaseValue: partialRight(getConvertedDatabaseValue, reduxState),
    isEmptyValue: partialRight(isEmptyValue, reduxState),
    selectUserByIdOptional: partial(selectUserByIdOptional, reduxState)
  };
}
